/**
 * ENTRÉE BOUTIQUE — /boutique-accueil
 * Hero premium autonome, pensé pour être partagé sur les réseaux sociaux.
 * Aucun lien vers les autres univers (membres/admin). CTA → /store.
 */
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

const HERO = "https://images.pexels.com/photos/10823766/pexels-photo-10823766.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export default function BoutiqueAccueil() {
  return (
    <div className="kz-body min-h-screen relative flex items-end bg-[#0A0A0A] overflow-hidden" data-testid="boutique-accueil">
      <img src={HERO} alt="Boutique Institut Impact" className="absolute inset-0 w-full h-full object-cover opacity-70" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/60 to-transparent" />

      {/* Logo en haut */}
      <img src="/logos/kaizen_system/generated/kaizen_system_master_white_on_black.png" alt="KAIZEN SYSTEM"
        className="absolute top-8 left-8 md:top-12 md:left-12 h-10 md:h-12 object-contain z-10" />

      <div className="relative z-10 max-w-4xl p-8 md:p-20 kz-fade-up">
        <span className="kz-mono text-white/70 tracking-[0.3em] uppercase text-xs md:text-sm mb-5 block">
          Boutique officielle · Institut Impact
        </span>
        <h1 className="kz-display text-5xl md:text-8xl font-medium text-white leading-[0.92] mb-6">
          Porte les couleurs<br />du dojo.
        </h1>
        <p className="kz-body text-white/70 text-base md:text-lg max-w-xl mb-10 font-light">
          Équipement officiel, gi BJJ, gants, protections et apparel custom — directement de Val-d'Or à travers le Canada. Paiement sécurisé.
        </p>
        <Link to="/store" data-testid="enter-store-btn"
          className="inline-flex items-center gap-4 bg-[#D90429] text-white px-9 py-5 font-bold tracking-wider hover:bg-white hover:text-black transition-colors duration-300 w-max">
          ENTRER DANS LA BOUTIQUE <ArrowRight size={20} weight="bold" />
        </Link>
      </div>
    </div>
  );
}
